import { render, staticRenderFns } from "./ContactsMenu.vue?vue&type=template&id=1563c388&scoped=true"
import script from "./ContactsMenu.vue?vue&type=script&lang=js"
export * from "./ContactsMenu.vue?vue&type=script&lang=js"
import style0 from "./ContactsMenu.vue?vue&type=style&index=0&id=1563c388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563c388",
  null
  
)

export default component.exports